export function loadChatPro() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://domingoalonso.my.site.com/ESWAgentforceChatWebSk1770139746855/assets/js/bootstrap.min.js';
  script.onload = function() {
    try {
      window.embeddedservice_bootstrap.settings.language = 'es';
      window.embeddedservice_bootstrap.init(
        '00D1i000000V9Lj',
        'Agentforce_Chat_Web_Skoda',
        'https://domingoalonso.my.site.com/ESWAgentforceChatWebSk1770139746855',
        {
          scrt2URL: 'https://domingoalonso.my.salesforce-scrt.com'
        }
      );
    } catch (err) {
      console.error('Error inicializando Agentforce:', err);
    }
  };
  document.head.appendChild(script);
}
